var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-container',{staticClass:"edit-profile-container"},[_c('change-profile-info-form'),_c('change-password-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }